// @owners { team: patients-team }
import { type Storage } from 'redux-persist';
import { Storage as MMKVStorage } from './storage';

export const reduxStorage: Storage = {
  // MMKV is synchronous but returning a promise for compatibility with redux-persist which expects async methods
  getItem: (key: string): Promise<string | null> => {
    return Promise.resolve(MMKVStorage.getString(key) ?? null);
  },

  // MMKV is synchronous but returning a promise for compatibility with redux-persist which expects async methods
  setItem: (key: string, value: string): Promise<void> => {
    MMKVStorage.set(key, value);
    return Promise.resolve();
  },

  // MMKV is synchronous but returning a promise for compatibility with redux-persist which expects async methods
  removeItem: (key: string): Promise<void> => {
    MMKVStorage.delete(key);
    return Promise.resolve();
  },
};
